const tooltips_text = {
    speichern: `Die Änderungen werden gespeichert, der Fragebogen kann weiter bearbeitet werden.`,
    versenden: `Der Fragebogen wird verschickt und kann anschließend nicht weiter bearbeitet werden.`,
    zuruecksetzen: `Alle nicht verschickten Antworten werden gelöscht!`,
    email_versenden: `Der Fragebogen wird per Email zum Ausfüllen an alle Empfänger versendet. `
}


export default tooltips_text;